import React from "react";

const QuizNavigation = ({ canGoBack, canSubmit, onBack, onNext }) => {
  return (
    <div className="tbb-quiz__nav">
      {canGoBack ? (
        <button
          type="button"
          className="tbb-quiz__back"
          onClick={onBack}
          aria-label="Go back"
        >
          &#8249;
        </button>
      ) : (
        /* Invisible spacer to maintain layout */
        <div style={{ width: "2.75rem", minWidth: "2.75rem" }} />
      )}
      <button
        type="button"
        className={`tbb-quiz__ok${!canSubmit ? " tbb-quiz__ok--disabled" : ""}`}
        onClick={onNext}
        disabled={!canSubmit}
      >
        OK
      </button>
    </div>
  );
};

export default QuizNavigation;
